module.exports = {
      id: "filter-icon-usage",
      viewBox: "0 0 13 14",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#filter-icon",
      toString: function () {
        return this.url;
      }
    }